import { render, staticRenderFns } from "./TipoServicoManage.vue?vue&type=template&id=8f0521b4&scoped=true"
import script from "./TipoServicoManage.vue?vue&type=script&lang=js"
export * from "./TipoServicoManage.vue?vue&type=script&lang=js"
import style0 from "./TipoServicoManage.vue?vue&type=style&index=0&id=8f0521b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0521b4",
  null
  
)

export default component.exports